import React, { useEffect } from "react";
import { Button, Grid, Stack, Typography } from "@mui/material";
import { AddOutlined } from "@mui/icons-material";

import AlertsTable from "../../../components/admin/alerts-manager/AlertsTable";
import { AlertsAddDrawer } from "../../../components/admin/alerts-manager/AlertsAddDrawer";
import { SearchRecords } from "../../../components/Common/SearchRecords";

import { useGetAlertsListQuery } from "../../../store/alerts/alertsApis";
import { defaultPaginate } from "../../../helpers/constants";

const AlertsContainer = (props) => {
    const { showDrawer, formType, initialValues, pagination, filters } = props;

    const queryParams = {
        page: pagination.pageNo + 1,
        limit: pagination.limit,
        sort_by: pagination.sortField,
        sort_order: pagination.sortBy,
        search: pagination.keywords || "",
        // Only include non-null filters
        ...(filters.is_active && filters.is_active !== "null" && { is_active: filters.is_active }),
        ...(filters.target_type && filters.target_type !== "null" && { target_type: filters.target_type }),
    };

    const { isLoading, data: alerts, isFetching } = useGetAlertsListQuery(queryParams);

    useEffect(() => {
        props.handlePaginationState(defaultPaginate);
    }, []);

    const handleAddAlert = () => {
        console.log("handleAddAlert called");
        props.changeAlertsInitialState({
            showDrawer: true,
            formType: "Add",
            initialValues: null,
        });
    };

    const handlePagination = (setting) => {
        props.handlePaginationState(setting);
    };

    const handleDrawerClose = () => {
        props.changeAlertsInitialState({
            showDrawer: false,
            formType: "",
            initialValues: null,
        });
    };

    const handleAlertEdit = (data, type) => {
        const payload = {
            id: data.id,
            title: data.title,
            content: data.content,
            target_type: data.target_type,
            target_roles: data.target_roles,
            target_users: data.target_users,
            expiry_date: data.expiry_date,
            is_active: data.is_active,
            images: data.images || [],
        };
        props.changeAlertsInitialState({
            showDrawer: true,
            formType: type,
            initialValues: payload,
        });
    };

    const handleSearch = (searchValue) => {
        props.handlePaginationState({
            ...pagination,
            keywords: searchValue,
            pageNo: 0,
        });
    };

    return (
        <Stack spacing={2}>
            <Grid container justifyContent="space-between">
                <Grid item xs={6} sx={{ alignSelf: "center" }}>
                    <Typography variant="h6">
                        Alerts{" "}
                        <span style={{ color: "gray", fontSize: "10px", verticalAlign: "super" }}>
                            ({alerts?.totalCount || 0})
                        </span>
                    </Typography>
                </Grid>
                <Grid
                    item
                    xs={6}
                    sx={{ alignSelf: "center" }}
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"flex-end"}
                >
                    <SearchRecords handlePagination={handlePagination} pagination={pagination} />
                    <Button
                        disableElevation
                        variant="contained"
                        sx={{
                            borderRadius: "8px",
                            marginLeft: 2,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            fontSize: "16px",
                        }}
                        onClick={() => handleAddAlert()}
                    >
                        <AddOutlined />
                        New Alert
                    </Button>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12}>
                    <AlertsTable
                        edit={(val, type) => handleAlertEdit(val, type)}
                        loading={isLoading}
                        fetching={isFetching}
                        count={alerts?.totalCount}
                        data={alerts?.results || []}
                        pagination={pagination}
                        handlePagination={(val) => handlePagination(val)}
                    />
                </Grid>
            </Grid>

            <AlertsAddDrawer
                show={showDrawer}
                close={handleDrawerClose}
                formType={formType}
                initialValues={initialValues}
            />
        </Stack>
    );
};

export default AlertsContainer;
